import styled, { css, keyframes } from "styled-components";

const fadeInAnim = keyframes`
  0%{
     transform: translateY(75px);
     opacity:0
  }
  10%{
    transition-timing-function: cubic-bezier(0.42, 0, 0.07, 0.92);
    transform: translateY(75px);
    opacity:0
  }
  50%{
    transition-timing-function: cubic-bezier(0.29, 0.2, 0.62, 1);
    transform:translateY(-10px);
    opacity:0.5;
  }
  100%{
    transform:translateY(0px)
    opacity:1
   } 
`;

const fadeOutAnim = keyframes`
  0%{
    transition-timing-function: cubic-bezier(0.35, 0, 0.2, 1);
     transform: translateY(0);
     opacity:1;
    }
    100%{
      transform:translateY(123px);
      opacity:0;
   } 
`;

const fadeIn = css`
  ${fadeInAnim} 0.55s 1 forwards
`;
const fadeOut = css`
  ${fadeOutAnim} 0.55s 1 forwards
`;

export const AutorulesDiv = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  animation: ${fadeIn};
  animation: ${(p) => (p.unBlur ? fadeOut : null)};
  opacity: 0.85;
  /* flex-direction: column; */
  height: 100%;
  width: 100%;

  background-color: #7f3da5;
  color: #ffb000;
  overflow-y: scroll;
  -ms-overflow-style: none; // IE 10+
  scrollbar-width: none; // Firefox
  &::-webkit-scrollbar {
    display: none; // Safari and Chrome
  }
  & > div > div {
    /* position: absolute;
    top: 50%;
    left: 50%;
    transform: translateY(-50%) translateX(-50%);
    width: 315px;
    height: 606px; */
  }
`;
export const Title = styled.div`
  height: 10px;
  font-size: 10px;
  color: #ffb000;
  /* margin-bottom: 9px; */
  margin: 9px 0;
`;
export const InputDiv = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  height: 56px;
  border-radius: 38px;
  background-color: transparent;
  color: #ffb000;
  border: solid 3px #ffb000;
  margin-bottom: 20px;
`;
export const InputBig = styled.input`
  width: 100%;
  height: 56px;
  border-radius: 38px;
  background-color: transparent;
  color: #ffb000;
  border: solid 3px #ffb000;
  margin-bottom: 20px;
  outline: none;
  padding: 20px;
  ::placeholder {
    color: #ffb000;
    opacity: 1; /* Firefox */
  }
`;
export const StopOnInput = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 56px;
  border-radius: 38px;
  border: solid 3px #ffb000;
  margin-bottom: 20px;
  padding: 20px;
  font-size: 12px;
  svg {
    width: 11px;
    height: 12px;
    margin: 0 2px;
  }
  input {
    background-color: transparent;
    color: #ffb000;
    outline: none;
    border: none;
    width: 100%;
    height: 12px;
    text-align: center;
    ::placeholder {
      color: #ffb000;
      opacity: 1; /* Firefox */
    }
  }
`;
const textAnim1 = keyframes`
  0%{
    animation-timing-function: cubic-bezier(0,0,0,1);
     color: #FFB000
  }
  100%{
     color: #ff3920
  } 
`;
const scaleAnim = keyframes`
  0%{
    animation-timing-function: cubic-bezier(.33,1,0,1);
    transform: scale(1)
   }
  50%{
    animation-timing-function: cubic-bezier(0,0,0,1);

    transform: scale(.73)
  }
  100%{
    transform: scale(1)
   } 
`;
const yellowDivOpa1 = keyframes`
  0%{
    animation-timing-function: cubic-bezier(0,0,0,1);
    opacity: 0;
    }
   
  100%{
    opacity:1
  } 
`;
const textAnim = css`
  ${textAnim1} 0.25s 1 forwards, ${scaleAnim} 0.33s 1 forwards
`;
const yellowDivOpa = css`
  ${yellowDivOpa1} 0.25s 1 forwards
`;
const whiteDivOpa1 = keyframes`
  0%{
    animation-timing-function: cubic-bezier(0,0,.2,1);
    opacity: 0;
    }
  33%{
    animation-timing-function: cubic-bezier(1.5,3.6,.2,1);
    opacity: 0.5;
    }
  100%{
    opacity:0
  } 
`;
const whiteDivOpa = css`
  ${whiteDivOpa1} 0.5s 1 forwards
`;
export const Reset = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 18px;
  width: 25.25%;
  height: 72%;
  font-size: 12px;
  animation: ${(p) => (p.active ? textAnim : null)};
  cursor: pointer;
  .yellow {
    position: absolute;
    top: -1px;
    left: -1px;
    height: 106%;
    width: 106%;
    border-radius: 18px;
    background: #ffb000;
    opacity: 0;
    animation: ${(p) => (p.active ? yellowDivOpa : null)};
  }
  .white {
    position: absolute;

    top: -1px;
    left: -1px;
    height: 106%;
    width: 106%;
    border-radius: 18px;
    background: #ffffff;
    opacity: 0;
    animation: ${(p) => (p.active ? whiteDivOpa : null)};
  }
  p {
    z-index: 1;
  }
  border: solid 3px #ffb000;
`;
export const Increase = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  width: 41.44%;
  height: 72%;
  border-radius: 18px;
  border: solid 3px #ffb000;
  font-size: 12px;
  animation: ${(p) => (p.active ? textAnim : null)};
  cursor: pointer;

  .yellow {
    position: absolute;
    /* top: -1px;
    left: -1px; */
    height: 106%;
    width: 106%;
    border-radius: 18px;
    background: #ffb000;
    opacity: 0;
    animation: ${(p) => (p.active ? yellowDivOpa : null)};
  }
  .white {
    position: absolute;
    width: 106%;
    height: 106%;
    border-radius: 18px;
    background: #ffffff;
    opacity: 0;
    animation: ${(p) => (p.active ? whiteDivOpa : null)};
  }
  p {
    z-index: 1;
  }
`;
export const Input = styled.input`
  width: 41px;
  height: 24px;
  font-size: 16px;
  background-color: transparent;
  border: none;
  outline: none;
  text-align: center;
  color: #ffb000;
  margin-right: 3px;
  ::placeholder {
    color: #ffb000;
  }
`;
const animSG1 = keyframes`
  0%{
    animation-timing-function: cubic-bezier(.33,1,0,1);
     transform:scale(1)
  }
  50%{
    animation-timing-function: cubic-bezier(0,0,0,1);
    transform:scale(.73)
  }
  100%{
    transform:scale(1)
   } 
`;

const animSG = css`
  ${animSG1} 0.3s 1 forwards
`;
const whitOpa1 = keyframes`
  0%{
    animation-timing-function: cubic-bezier(0,0,.2,1);
    opacity:0;
  }
  33%{
    animation-timing-function: cubic-bezier(.15,.36,.2,1);
    opacity:0.5;
   }
  100%{
    opacity:0;
   } 
`;
const whitOpa = css`
  ${whitOpa1} 0.5s 1 forwards
`;

export const PlayBtn = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 320px;
  font-size: 20px;
  border-radius: 38px;
  background-color: #ffb000;
  color: #ff3920;
  margin-bottom: 24px;
  padding: 15px 0 17px;
  animation: ${(p) => (p.animSG ? animSG : null)};
  cursor: pointer;
  /* .yellow {
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 50px;
    background: #ffb000;
    opacity: 0;
  } */
  .white {
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 50px;
    background: #ffffff;
    opacity: 0;
    animation: ${(p) => (p.animSG ? whitOpa : null)};
  }
`;
export const BackBtn = styled.div`
  color: #ffb000;
  font-size: 20px;
  text-align: center;
  width: 100%;
  max-width: 320px;
  cursor: pointer;
`;
export const Bet = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 320px;
  margin-bottom: 18px;
`;
export const BetQuantity = styled.div`
  font-size: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 56.69%;
  height: 56px;
  border-radius: 38px;
  border: solid 3px#ffb000;
  input {
    font-size: 12px;
    text-align: center;
    height: 40px;
    width: 100px;
    color: #ffb000;
    background: transparent;
    outline: none;
    border: none;
  }
`;

export const Opr = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 56px;
  height: 56px;
  border-radius: 28px;
  background-color: #ffb000;
  transform: scale(1);
  cursor: pointer;

  ${(p) =>
    p.plusPress || p.minusPress
      ? "transform: scale(0.83); transition-timing-function: cubic-bezier(0.33, 1, 0, 0); transition: transform 167ms;"
      : "transform: scale(1); transition-timing-function: cubic-bezier(0, 0, 0, 1); transition: transform 167ms;"}

  ::after {
    content: "";
    position: absolute;
    opacity: 0;
    width: 56px;
    height: 56px;
    border-radius: 28px;
    background-color: white;
    ${(p) =>
    p.plusPress || p.minusPress
      ? "opacity: 0.5;  transition-timing-function: cubic-bezier(0.17, 0.17, 0.2, 1); transition: opacity 167ms;"
      : "opacity: 0;  transition-timing-function: cubic-bezie(0.17, 0.33, 0.2, 1); transition: opacity 333ms"}
  }

  svg {
    pointer-events: none;
  }
`;
export const AutoRuleBox = styled.div`
  width: 100%;
  max-width: 320px;
  position: relative;
  .infinite {
    height: 48px;
    width: 20px;
    top: 23px;
    position: absolute;
    left: 25px;
    pointer-events: none;
  }
  path {
    fill: #ffb000;
  }
`;
export const ProfitBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 320px;
  width: 100%;

  div {
    width: 47.306%;
  }
  div > div {
    width: 100%;
  }
`;
